import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputForm from "../../../../components/input/input-form.jsx";
import InputRadio from "../../../../components/input/input-radio.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters, boName, hasBo }) => {
    const {
        boAuditStatus,
        boAuditValidatedLogin,
        boAuditValidatedName,
        boAuditValidatedCPF
    } = useReportFiltersFetch({
        fetchBoAuditorshipStatus: true,
        fetchBoAuditorshipValidatedLogin: true,
        fetchBoAuditorshipValidatedName: true,
        fetchBoAuditorshipValidatedCPF: true
    });

    const hasSelectedValue = (option) => option?.value !== null && option?.value !== undefined;

    const hasLogin = hasSelectedValue(filters.userLogin);
    const hasName = hasSelectedValue(filters.userName);
    const hasCpf = hasSelectedValue(filters.userCpf);

    const disabledLogin = hasName || hasCpf;
    const disabledName = hasLogin || hasCpf;
    const disabledCpf = hasLogin || hasName;

    const normalizeCpf = (value = "") => String(value).replace(/\D/g, "");

    const cpfFilterOption = (option, inputValue) => {
        const label = option?.label || option?.data?.label || "";
        const value = option?.value || option?.data?.value;
        const normalizedInput = normalizeCpf(inputValue);

        if (value === "*") {
            return boAuditValidatedCPF.some(opt =>
                normalizeCpf(opt.label).startsWith(normalizedInput)
            );
        }

        if (!normalizedInput) return true;
        return normalizeCpf(label).startsWith(normalizedInput);
    };

    const setUserFilter = (field, value) => {
        setFilters(prev => ({
            ...prev,
            userLogin: null,
            userName: null,
            userCpf: null,
            [field]: value,
        }));
    }

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label={`Data/hora inicial ${!hasBo ? '*' : ''}`}
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label={`Data/hora final ${!hasBo ? '*' : ''}`}
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputForm
                        id="bo"
                        label={`Número ${boName}`}
                        value={filters.bo}
                        onChange={({target}) => setFilters(prev => ({ ...prev, bo: target.value }))}
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <SelectComponent
                        id="status"
                        label="Status"
                        isMulti={true}
                        wrapValues={true}
                        options={boAuditStatus}
                        value={filters.status}
                        onChange={(value) => setFilters(prev => ({...prev, status: value}))}
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        id="relations"
                        label="Relacionado à"
                        isMulti={false}
                        wrapValues={true}
                        options={[
                            {label: "Todos", value: 'all'},
                            {label: "Abordagem", value: 'encounter_relation'},
                            {label: "Despacho", value: 'dispatch_relation'}
                        ]}
                        value={filters.relations}
                        onChange={(value) => setFilters(prev => ({...prev, relations: value}))}
                        classNameWrapper={"w-full"}
                        isClearable={false}
                    />

                    <div className="separator mb-3"> Acesso </div>

                    <SelectComponent
                        id="login"
                        label="Login"
                        isMulti={false}
                        wrapValues={true}
                        options={boAuditValidatedLogin}
                        value={filters.userLogin}
                        onChange={(value) => setUserFilter('userLogin', value)}
                        classNameWrapper={"w-full"}
                        isDisabled={disabledLogin}
                    />

                    <SelectComponent
                        id="name"
                        label="Nome"
                        isMulti={false}
                        wrapValues={true}
                        options={boAuditValidatedName}
                        value={filters.userName}
                        onChange={(value) => setUserFilter('userName', value)}
                        classNameWrapper={"w-full"}
                        isDisabled={disabledName}
                    />

                    <SelectComponent
                        id="cpf"
                        label="CPF"
                        isMulti={false}
                        wrapValues={true}
                        options={boAuditValidatedCPF}
                        value={filters.userCpf}
                        onChange={(value) => setUserFilter('userCpf', value)}
                        classNameWrapper={"w-full"}
                        isDisabled={disabledCpf}
                        filterOption={cpfFilterOption}
                        cpfFilter
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;